
import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle, Calendar, Clock, ArrowLeft } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Helmet } from "react-helmet-async";

const BookingSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get('booking') || 'confirmed';
  const meetingName = searchParams.get('meeting') || 'Your Meeting';
  const date = searchParams.get('date') || '';
  const time = searchParams.get('time') || '';

  return (
    <>
      <Helmet>
        <title>Booking Confirmed | ChronoCal</title>
        <meta name="description" content="Your meeting has been successfully booked." />
        <meta name="robots" content="noindex" />
      </Helmet>
      
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
        <Card className="w-full max-w-md">
          <CardContent className="py-8 px-6 text-center">
            <div className="mb-6">
              <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-gray-900 mb-2">
                Booking Confirmed!
              </h1>
              <p className="text-gray-600">
                Your meeting has been successfully scheduled.
              </p>
            </div>

            <div className="space-y-4 mb-6">
              <div className="bg-gray-50 rounded-lg p-4">
                <h2 className="font-semibold text-gray-900 mb-3">{meetingName}</h2>
                
                {date && (
                  <div className="flex items-center justify-center text-gray-600 mb-2">
                    <Calendar className="h-4 w-4 mr-2" />
                    <span>{date}</span>
                  </div>
                )}
                
                {time && (
                  <div className="flex items-center justify-center text-gray-600">
                    <Clock className="h-4 w-4 mr-2" />
                    <span>{time}</span>
                  </div>
                )}
              </div>
              
              <p className="text-sm text-gray-500">
                A confirmation email has been sent with meeting details and any necessary links.
              </p>
            </div>

            <div className="space-y-3">
              <Button asChild className="w-full">
                <Link to="/">
                  Return to ChronoCal
                </Link>
              </Button>
              
              <Button variant="outline" asChild className="w-full">
                <Link to="/" className="flex items-center justify-center">
                  <ArrowLeft className="h-4 w-4 mr-2" />
                  Schedule Another Meeting
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default BookingSuccessPage;
